import React from 'react';
export function EditorialFooter() {
  return <footer className="bg-[#1a1a1a] text-gray-400 py-12 px-4 border-t-4 border-[#C0392B]" data-id="element-16">
      <div className="max-w-4xl mx-auto text-xs leading-relaxed space-y-6" data-id="element-17">
        <div className="uppercase tracking-widest text-white font-bold mb-4 text-center" data-id="element-18">
          Living & Wellness
        </div>

        <p className="text-justify opacity-80" data-id="element-19">
          Results vary. Lumera is a personal wellness device for home use and is
          not a medical device. If you are experiencing severe or persistent
          knee pain, please consult a healthcare professional.
        </p>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gray-800 mt-8" data-id="element-20">
          <p data-id="element-21">&copy; 2026 Living & Wellness. All Rights Reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-22">
            <a href="#" className="hover:text-white transition-colors" data-id="element-23">
              About Us
            </a>
            <a href="https://lumeraa.net/policies/terms-of-service" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-24">
              Terms of Service
            </a>
            <a href="https://lumeraa.net/policies/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-25">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}